import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import Antd from "ant-design-vue";
import './assets/css/bootstrap.css'
import "ant-design-vue/dist/antd.less";
import "./icon/yzIndex.css";
import i18n from "./lang/index";
import store from "./store/index";
import "./icon/iconfont.css";
import "@babel/polyfill";
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/index.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import "./assets/css/index.css";
import vcolorpicker from 'vcolorpicker'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import MessagePlugin from './plugins/customMessage.js';
import ConfirmPlugin from './plugins/customConfirm.js';
import sessionManager from './utils/session-manager';
Vue.prototype.$sessionManagerService = sessionManager;

Vue.use(ConfirmPlugin);
Vue.use(MessagePlugin);
Vue.use(ElementUI);
Vue.use(vcolorpicker)
Vue.use(ViewUI);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(VXETable);
Vue.use(Antd);
Vue.config.productionTip = false;
Vue.filter("SubLength", val => {
  if (val.length > 12) {
    return val.substring(0, 12) + "...";
  } else {
    return val;
  }
});

// Vue.filter("textValFilter", val => {
//     return val + '66'
// });

// import "./assets/css/bootstrap.css"
import VXETablePluginAntd from 'vxe-table-plugin-antd'
// import "vxe-table-plugin-antd/dist/style.css";
VXETable.use(VXETablePluginAntd)

 new Vue({
  el: "#app",
  i18n,
  router,
  store,
  render: h => h(App)
});
